import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-records-check',
  templateUrl: './nr.component.html',
  styleUrls: ['./nr.component.scss'],
})
export class AppNoRecordsViewComponent {
  public showMessage: boolean = false;

  constructor() {
  }

  @Input()
  set records(value) {
    if (value) {
      if (!value.length) {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }
    } else {
      this.showMessage = true;
    }
  }

  @Input() public message: string = 'NO RECORDS TO DISPLAY';

}



// WEBPACK FOOTER //
// ./src/shared/no-records.component/nr.component.ts